import * as React from 'react';
import { Link } from 'react-static';
import SVGInline from 'react-svg-inline';

import LinkButton from '../Button/LinkButton';
import { routePaths } from '../../../config/routePaths';
import { Language } from '../../containers/Localization/localizationDuck';

import { LogoRowLocale } from './logoRow.locale';

import styles from './LogoRow.scss';

import logo from './peering-logo.svg';

interface LogoRowProps {
  currentLanguage: Language;
  locale: LogoRowLocale;
}

const LogoRow: React.SFC<LogoRowProps> = ({ currentLanguage, locale }) => (
  <div className={styles.container}>
    <Link to={routePaths.homepage[currentLanguage]}>
      <SVGInline svg={logo} className={styles.logo} />
    </Link>
    <LinkButton to="https://client.peering.cz/auth" target="_blank" rel="noopener">
      {locale.clientLogin}
    </LinkButton>
  </div>
);

export default LogoRow;



// WEBPACK FOOTER //
// /www/client/src/components/LogoRow/LogoRow.tsx